import {
  AnchorButton,
  Classes,
  Intent,
  Position,
  Spinner,
  SpinnerSize,
} from '@blueprintjs/core';
import * as React from 'react';
import { Tooltip } from 'vet-bones/components';

import { TEST_IDS } from 'src/constants/testIds';
import { ProjectResourceDialogFooterProps } from 'src/containers/ProjectResourceDialog/types';
import * as copy from 'src/templates/copy';

export const ProjectResourceDialogFooter: React.VFC<
  ProjectResourceDialogFooterProps
> = ({
  createAndMapButtonPending,
  createButtonsError,
  handleBackButtonClick,
  handleCreateAndMapButtonClick,
  handleCreateButtonClick,
}) => {
  return (
    <div className={Classes.DIALOG_FOOTER}>
      <div className={Classes.DIALOG_FOOTER_ACTIONS}>
        {handleBackButtonClick ? (
          <AnchorButton
            data-testid={TEST_IDS.projectResourceDialog.backButton}
            intent={Intent.PRIMARY}
            onClick={handleBackButtonClick}
            outlined
            text={copy.components.projectResourceDialog.backButton}
          />
        ) : null}
        <Tooltip
          content={createButtonsError || ''}
          disabled={!createButtonsError}
          position={Position.BOTTOM}
        >
          <div>
            {handleCreateButtonClick ? (
              <AnchorButton
                data-testid={TEST_IDS.projectResourceDialog.createButton}
                disabled={Boolean(
                  createAndMapButtonPending || createButtonsError
                )}
                intent={Intent.PRIMARY}
                onClick={handleCreateButtonClick}
                text={copy.components.projectResourceDialog.createButton}
              />
            ) : null}
            {handleCreateAndMapButtonClick ? (
              <AnchorButton
                data-testid={TEST_IDS.projectResourceDialog.createAndMapButton}
                disabled={Boolean(
                  createAndMapButtonPending || createButtonsError
                )}
                intent={Intent.PRIMARY}
                onClick={handleCreateAndMapButtonClick}
                rightIcon={
                  createAndMapButtonPending ? (
                    <Spinner size={SpinnerSize.SMALL} />
                  ) : undefined
                }
                text={copy.components.projectResourceDialog.createAndMapButton}
              />
            ) : null}
          </div>
        </Tooltip>
      </div>
    </div>
  );
};
